module.exports = __webpack_public_path__ + "img/bottom_phone.b67ea49a.png";